
// import Meme from './Components/Meme'
import Memespace from './Components/Memespace';
import Navbar from './Components/Navbar';

function App() {
  return (

    <div className="App">
      <Navbar/>
      <Memespace>
  
      </Memespace>
    </div>

  );
}

export default App;
